import React from 'react'
import { object, shape, number } from 'prop-types'

import range from 'lodash/range'

import Cell from './Cell'

function getGridValue (gridValues, sValue, cValue) {
  if (typeof gridValues[sValue] === 'object') {
    return gridValues[sValue][cValue] || '0'
  }
  return '0'
}

function Row (props) {
  const {
    s, using: { fromCell }, scope: { cMax, cMin, interval }, rangeColors, gridValues, style,
  } = props

  return (
    <div className={style.row}>
      <div className={style.titleS}>
        {(s % 50 === 0) ? s / 100 : ''}
      </div>

      {range(cMax, cMin + interval, interval).map(c => (
        <Cell
          {...{ ...props, c }}
          key={c}
          isFromCell={fromCell !== null && fromCell.s === s && fromCell.c === c}
          color={rangeColors[getGridValue(gridValues, s, c)]}
        />
      ))}
    </div>
  )
}
Row.propTypes = {
  gridValues: object.isRequired,
  scope: shape({
    s: shape({
      max: number.isRequired,
      min: number.isRequired,
      interval: number.isRequired,
    }),
    c: shape({
      max: number.isRequired,
      min: number.isRequired,
      interval: number.isRequired,
    }),
  }),
  s: number.isRequired,
  rangeColors: object.isRequired,
  using: object.isRequired,
  // clickCell: func,
  style: object.isRequired,
}

export default Row



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/Row/Row.jsx